import { render, staticRenderFns } from "./MemorySimpleTable.vue?vue&type=template&id=24af2df3"
import script from "./MemorySimpleTable.vue?vue&type=script&lang=js"
export * from "./MemorySimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports